var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-horizontal-list',{attrs:{"items":_vm.items,"options":_vm.vhlOptions},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_vm._t("default",[_c('ItemCard',{attrs:{"showBookmarkAction":true,"showEditProjectIcon":false,"item":item}})],{"item":item})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }